import React from 'react';
import { Range } from 'react-range';

const SliderForm = ({ values, onChange }) => {
  const labels = [
    "Developing new features and upgrading capabilities",
    "Maintaining existing code including tech debt and bugs",
    "Assisting other team members through code reviews or other tasks",
    "Other including meetings, learning time, etc."
  ];

  const handleSliderChange = (index, newValue) => {
    const newValues = [...values];
    newValues[index] = Math.max(0, Math.min(100, newValue));

    // Calculate the remaining percentage
    const remainingPercentage = 100 - newValues[index];
    const otherIndices = [0, 1, 2, 3].filter(i => i !== index);
    const otherTotal = otherIndices.reduce((acc, i) => acc + newValues[i], 0);

    if (otherTotal === 0) {
      // If the other sliders total to 0, set them all to 0
      otherIndices.forEach(i => {
        newValues[i] = 0;
      });
    } else {
      // Adjust other sliders proportionally
      otherIndices.forEach(i => {
        newValues[i] = Math.round((newValues[i] / otherTotal) * remainingPercentage);
      });
    }

    onChange(newValues);
  };

  return (
    <div className="p-4">
      {values.map((value, index) => (
        <div key={index} className="mb-4">
          <label className="block mb-2 font-semibold">{labels[index]}</label>
          <div className="flex items-center">
            <span className="mr-2 text-sm">0%</span>
            <Range
              step={1}
              min={0}
              max={100}
              values={[value]}
              onChange={(newValue) => handleSliderChange(index, newValue[0])}
              renderTrack={({ props, children }) => {
                const { key, ...restProps } = props; // Exclude key
                return (
                  <div
                    {...restProps}
                    style={{
                      ...restProps.style,
                      height: '6px',
                      width: '100%',
                      backgroundColor: '#ccc',
                    }}
                  >
                    {React.Children.map(children, (child, i) => (
                      React.cloneElement(child, { key: i }) // Ensure each child has a unique key
                    ))}
                  </div>
                );
              }}
              renderThumb={({ props }) => {
                const { key, ...restProps } = props; // Exclude key
                return (
                  <div
                    {...restProps}
                    style={{
                      ...restProps.style,
                      height: '20px',
                      width: '20px',
                      backgroundColor: '#999',
                      borderRadius: '50%',
                    }}
                  />
                );
              }}
            />
            <span className="ml-2 text-sm">100%</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SliderForm;
